import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { SEO } from '@store/components/SEO';
import { ContactUs } from '@store/components/ContactUs/ContactUs';
import { withPageTitle } from '@store/components/withPageTitle';
import { useTranslation } from '@yoweb/next-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * The Contact us page.
 */
var ContactUsPage = function ContactUsPage() {
  var _useTranslation = useTranslation('contact-us'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SEO, {
      description: t('page-description')
    }), /*#__PURE__*/_jsx(ContactUs, {})]
  });
};

ContactUsPage.layout = {
  type: 'marketing'
};
export var __N_SSP = true;
export default _withSuperJSONPage(withPageTitle(ContactUsPage)({
  translationKey: 'contact',
  translationNS: 'contact-us'
}));